import { createRouter, createWebHistory } from "vue-router";

// Define your routes
const routes = [
  {
    path: "/",
    name: "AppHome",

    component: () => import("../pages/homePage.vue"), // Lazy-loaded
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../pages/MBBMHome.vue"), // Lazy-loaded
  },
  {
    path: "/createStory",
    name: "CreateStory",
    component: () => import("../pages/CreateStory.vue"), // Lazy-loaded
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/LoginPage.vue"),
    //component: () => import("../pages/RegistrationPage.vue"), // Lazy-loaded
  },
  {
    path: "/registration",
    name: "registration",
    //component: () => import("../pages/LoginPage.vue"),
    component: () => import("../pages/RegistrationPage.vue"), // Lazy-loaded
  },
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
